import { forwardRef } from "react";
import { isNil } from "lodash";
import { NumberField } from "./NumberField";
import type { YearFieldProps } from "./types";
import style from "./YearField.module.scss";

const YEAR_INPUT_PATTERN = /^\d{0,4}$/;

export const YearField = forwardRef<HTMLInputElement, YearFieldProps>(function YearField(
    { id, placeholder, ariaLabel, value, onChange, required, customValidation, ...rest },
    ref,
) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const raw = event.target.value;
        if (raw === "" || YEAR_INPUT_PATTERN.test(raw)) {
            onChange(raw === "" ? null : Number(raw));
        }
    };

    return (
        <NumberField
            id={id}
            ref={ref}
            ariaLabel={ariaLabel}
            required={required}
            placeholder={placeholder}
            onChange={handleChange}
            value={isNil(value) ? "" : String(value)}
            className={style.yearField}
            validationPattern="year"
            customValidation={customValidation}
            type="text"
            inputMode="numeric"
            maxLength={4}
            {...rest}
        />
    );
});
